import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { User } from 'store/User';

export const HOLIDAY_TYPE_HOLIDAY = 'holiday';
export const HOLIDAY_TYPE_SICK = 'sick';
export const HOLIDAY_TYPE_CONFERENCE = 'conference';
export const HOLIDAY_TYPE_OTHER = 'other';

export const HOLIDAY_TYPES = [
    HOLIDAY_TYPE_HOLIDAY,
    HOLIDAY_TYPE_SICK,
    HOLIDAY_TYPE_CONFERENCE,
    HOLIDAY_TYPE_OTHER,
];

const isoDate = {
    parse(_attr: string, value: string | null) {
        if (value === null) {
            return null;
        }
        return value;
    },
    toJS(_attr: string, value: string | null) {
        return value;
    },
};

export class DeveloperHoliday extends Model {
    static backendResourceName = 'developer_holiday';

    @observable id = null;
    @observable user = this.relation(User);
    @observable startDate = null;
    @observable endDate = null;
    @observable note = '';
    @observable holidayType = HOLIDAY_TYPE_HOLIDAY;

    casts() {
        return {
            startDate: isoDate,
            endDate: isoDate,
        };
    }
}

export class DeveloperHolidayStore extends Store {
    Model = DeveloperHoliday;
    static backendResourceName = 'developer_holiday';
}
